import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveDynamicComponent as _resolveDynamicComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, renderSlot as _renderSlot, createVNode as _createVNode } from "vue"

const _hoisted_1 = { key: 1 }

import { reactive } from 'vue';
import { useStore } from 'vuex';
import { useI18n } from '@shell/composables/useI18n';
import { LABELS_TO_IGNORE_REGEX, ANNOTATIONS_TO_IGNORE_REGEX } from '@shell/config/labels-annotations';
import { Factory } from '@shell/components/form/Labels.vue';
import RcKeyValue from '@shell/components/form/RcKeyValue.vue';
import { RcContentGroup } from '@components/Layout';


export default /*@__PURE__*/_defineComponent({
  __name: 'RcLabels',
  props: {
    value: {},
    mode: {},
    annotationTitleTooltip: { default: '' },
    showLabels: { type: Boolean, default: true },
    showAnnotations: { type: Boolean, default: true },
    showLabelTitle: { type: Boolean, default: true },
    showAnnotationTitle: { type: Boolean, default: true },
    showLabelDescription: { type: Boolean, default: true },
    addIcon: { default: '' },
    compact: { type: Boolean, default: false },
    useRcButton: { type: Boolean, default: false },
    showSystemKeys: { type: Boolean, default: false }
  },
  setup(__props: any) {

/**
 * A version of Labels laid out for use inside RcSection: the header,
 * description and key/value lists are stacked with RcContentGroup and the
 * lists use RcKeyValue, so everything sits 16px apart.
 *
 * Unlike Labels it has no "Show System Labels and Annotations" toggle; the
 * parent owns that toggle and passes its state in via showSystemKeys.
 */
const props = __props;

const store = useStore();
const { t } = useI18n(store);

const protectedWarning = t('labels.protectedWarning');
const readOnlyWarning = t('labels.readOnlyWarning');

const labels = reactive(new Factory(props.value.systemLabels, LABELS_TO_IGNORE_REGEX, protectedWarning, props.value.labels));
const annotations = reactive(new Factory(
  props.value.systemAnnotations,
  ANNOTATIONS_TO_IGNORE_REGEX,
  protectedWarning,
  props.value.annotations,
  props.value.allowedSystemAnnotationKeys,
  props.value.readOnlyAnnotationKeys,
  readOnlyWarning
));

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(RcContentGroup), { class: "rc-labels" }, {
    default: _withCtx(() => [
      (__props.showLabels)
        ? (_openBlock(), _createBlock(_unref(RcContentGroup), { key: 0 }, {
            default: _withCtx(() => [
              (__props.showLabelTitle)
                ? (_openBlock(), _createBlock(_resolveDynamicComponent(!__props.compact ? 'h3' : 'h4'), { key: 0 }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_unref(t)('labels.labels.title')), 1)
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true),
              _cache[2] || (_cache[2] = _createTextVNode()),
              (__props.showLabelDescription)
                ? (_openBlock(), _createElementBlock("p", _hoisted_1, _toDisplayString(_unref(t)('labels.labels.description')), 1))
                : _createCommentVNode("", true),
              _cache[3] || (_cache[3] = _createTextVNode()),
              _renderSlot(_ctx.$slots, "labels", {}, () => [
                _createVNode(RcKeyValue, {
                  key: "labels",
                  "data-testid": "labels-keyvalue",
                  value: __props.showSystemKeys ? labels.initValue : labels.value,
                  "add-label": _unref(t)('labels.addLabel'),
                  "add-icon": __props.addIcon,
                  mode: __props.mode,
                  "read-allowed": false,
                  "value-can-be-empty": true,
                  "key-errors": labels.keyErrors,
                  "use-rc-button": __props.useRcButton,
                  "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => (labels.update($event, (x) => __props.value.setLabels(x))))
                }, null, 8, ["value", "add-label", "add-icon", "mode", "key-errors", "use-rc-button"])
              ])
            ]),
            _: 3
          }))
        : _createCommentVNode("", true),
      _cache[4] || (_cache[4] = _createTextVNode()),
      (__props.showAnnotations)
        ? (_openBlock(), _createBlock(RcKeyValue, {
            key: "annotations",
            "data-testid": "annotations-keyvalue",
            value: __props.showSystemKeys ? annotations.initValue : annotations.value,
            "add-label": _unref(t)('labels.addAnnotation'),
            "add-icon": __props.addIcon,
            mode: __props.mode,
            title: __props.showAnnotationTitle ? _unref(t)('labels.annotations.title') : undefined,
            "title-protip": __props.annotationTitleTooltip,
            "read-allowed": false,
            "value-can-be-empty": true,
            "key-errors": annotations.keyErrors,
            "disabled-keys": __props.value.readOnlyAnnotationKeys || [],
            "use-rc-button": __props.useRcButton,
            "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => (annotations.update($event, (x) => __props.value.setAnnotations(x))))
          }, null, 8, ["value", "add-label", "add-icon", "mode", "title", "title-protip", "key-errors", "disabled-keys", "use-rc-button"]))
        : _createCommentVNode("", true)
    ]),
    _: 3
  }))
}
}

})